import { render } from "./MeusPlanos.vue?vue&type=template&id=6f2b8fec&scoped=true"
import script from "./MeusPlanos.vue?vue&type=script&lang=js"
export * from "./MeusPlanos.vue?vue&type=script&lang=js"

import "./MeusPlanos.vue?vue&type=style&index=0&id=6f2b8fec&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2b8fec"]])

export default __exports__